import { styled } from '@mui/material/styles';
import { ToolbarButton } from '../lib/dataGrid';

/**
 * The grid toolbar's add button, marked by the icon's COLOUR alone: an outline
 * around one icon in a row of bare ones reads as a stray element, and colouring
 * the icon is how this toolbar says things anyway (see `ActiveToolButton`).
 *
 * Styled rather than given an `sx` — the grid's ToolbarButton takes a className
 * and no system props.
 */
const AddToolButton = styled(ToolbarButton)(({ theme }) => ({
    color: theme.palette.primary.main
}));

export default AddToolButton;
